class VideoCarouselItem extends HTMLElement {}

class VideoCarousel extends HTMLElement {
  #currentIndex = 0;
  #items = [];
  #isPortrait = false;
  #mobileQuery = window.matchMedia('(max-width: 749px)');

  connectedCallback() {
    this.#items = Array.from(this.querySelectorAll(':scope > .video-carousel__track > video-carousel-item'));

    if (this.#items.length <= 1) {
      this.querySelector('.video-carousel__arrow--prev')?.remove();
      this.querySelector('.video-carousel__arrow--next')?.remove();
      return;
    }

    // Portrait mode when ALL items are portrait aspect ratio
    this.#isPortrait = this.#items.every((item) => {
      const ar = parseFloat(item.dataset.aspectRatio);
      return !isNaN(ar) && ar < 1;
    });

    if (this.#isPortrait) {
      this.classList.add('video-carousel--portrait');
    }

    this.#update();

    this.querySelector('[data-carousel-action="previous"]')
      ?.addEventListener('click', () => this.#navigate(-1));
    this.querySelector('[data-carousel-action="next"]')
      ?.addEventListener('click', () => this.#navigate(1));

    this.#mobileQuery.addEventListener('change', () => this.#update());
  }

  #navigate(dir) {
    this.#currentIndex = (this.#currentIndex + dir + this.#items.length) % this.#items.length;
    this.#update();
  }

  #update() {
    const total = this.#items.length;
    const isMobile = this.#mobileQuery.matches;
    const showSides = this.#isPortrait && !isMobile;

    this.#items.forEach((item, i) => {
      const diff = ((i - this.#currentIndex) % total + total) % total;
      const pos = diff > total / 2 ? diff - total : diff;

      item.classList.toggle('is-active', pos === 0);
      item.classList.toggle('is-prev', pos === -1);
      item.classList.toggle('is-next', pos === 1);

      const visible = pos === 0 || (showSides && Math.abs(pos) === 1);
      item.style.display = visible ? '' : 'none';
    });
  }
}

if (!customElements.get('video-carousel-item')) {
  customElements.define('video-carousel-item', VideoCarouselItem);
}
if (!customElements.get('video-carousel')) {
  customElements.define('video-carousel', VideoCarousel);
}
